import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
	selectPaymentRequestsLimits: "selectPaymentRequestsLimits [Action]",
	selectPaymentRequestsLimitsLoading:
		"selectPaymentRequestsLimitsLoading [Action]",
	selectPaymentRequestsLimitsAsync: "selectPaymentRequestsLimitsAsync [Action]",
};
const inistiaState = {
	data: [],
	loading: false,
	total: 0,
};

export const selectPaymentRequestsLimitsReducer = (
	state = inistiaState,
	{ type, payload },
	
) => {

	switch (type) {
		case actionTypes.selectPaymentRequestsLimits:
			return {
				...state,
				data: payload,
				total: payload?.total,
			};
		case actionTypes.selectPaymentRequestsLimitsLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	
	yield put({
		type: actionTypes.selectPaymentRequestsLimitsLoading,
		payload: true,
	});

	let config = {
		url: "select_request",
	};

	let data = {
		table: "payment",
		method_type: "select_bank_data",
		data: payload?.data ? payload.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		
		
		let isOk = handleNotificationAlertTrySelect(res);
		if (!isOk) {
			return;
		}

		yield put({
			type: actionTypes.selectPaymentRequestsLimits,
			payload: res?.data?.response?.data,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({
			type: actionTypes.selectPaymentRequestsLimitsLoading,
			payload: false,
		});
	}
}

export function* selectPaymentRequestsLimits() {
	yield takeLatest(actionTypes.selectPaymentRequestsLimitsAsync, handleWorker);
}
